import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { convertNameToAvatarPlaceholder } from 'helpers/formatters';
import { openNotificationsDrawerEffect } from 'store/effects/drawers/notifications';
import { LocationService } from 'services';
import BaseNotification from '../../../BaseNotification';

import styles from './styles.module.scss';
import ProfileExpanded from 'components/ClientsDrawer/ProfileClient/ExpandedSection';
import { requestGetClientsListEffect } from 'store/effects/clientsList';

const locationSrv = new LocationService();

const ClientPreferencesUpdated = (props) => {
  const {
    className,
    Ids,
    IsRead,
    CreatedDate,
    Payload,
    groupType,
    title,
    SeverityLevel,
    IsPinned,
    Type,
  } = props;

  const [openProfileModal, setOpenProfileModal] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  locationSrv.setLocation(location);

  const { ClientId, ClientFirstName, ClientLastName, ClientAvatarUrl } = Payload || {};

  const Name = `${ClientFirstName} ${ClientLastName}`;

  const onClickHandler = () => {
    if (
      [
        'ClientSearchNew',
        'ClientSearchReactivated',
        'ClientSearchDeactivated',
        'ClientSearchCriteriaChange',
      ].includes(Type) &&
      Payload?.OriginalLink
    ) {
      const url = new URL(Payload.OriginalLink);
      history.push(`${url.pathname}${url.search}`);
      return;
    }
    dispatch(requestGetClientsListEffect());
    setOpenProfileModal(true);
  };

  return (
    <div className={classNames(styles.notificationClientPrefsUpdated, className)}>
      <BaseNotification
        ids={Ids}
        isRead={IsRead}
        title={title}
        date={CreatedDate}
        groupType={groupType}
        avatarUrl={ClientAvatarUrl}
        avatarPlaceholder={convertNameToAvatarPlaceholder(Name)}
        severityLevel={SeverityLevel}
        onClick={onClickHandler}
        IsPinned={IsPinned}
      />
      {openProfileModal && (
        <>
          <ProfileExpanded
            id={ClientId}
            isAgent={false}
            activeTab={2}
            isModalOpened={true}
            setModalClose={() => setOpenProfileModal(false)}
          />
        </>
      )}
    </div>
  );
};

ClientPreferencesUpdated.propTypes = {
  Ids: PropTypes.arrayOf(PropTypes.number).isRequired,
  Payload: PropTypes.shape({
    ClientFirstName: PropTypes.string,
    ClientLastName: PropTypes.string,
    ClientAvatarUrl: PropTypes.string,
    ClientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }).isRequired,
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  IsRead: PropTypes.bool.isRequired,
  CreatedDate: PropTypes.string.isRequired,
  groupType: PropTypes.string.isRequired,
  SeverityLevel: PropTypes.string,
};

ClientPreferencesUpdated.defaultProps = {
  className: '',
};

export default ClientPreferencesUpdated;
